import { ProductType } from '@/types';
import { getDefaultValues } from './getDefaultValues';

export const getDefaultViewId = (productType: ProductType) =>
  getDefaultValues(productType).defaultView.id;
